import feather from "feather-icons";

document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

$(document).ready(function () {
	feather.replace()
});

$(function () {
	const $toggleButton = $('#mobileMenuToggle');
	const $mobileMenu = $('#mobileMenu');
	const $iconOpen = $('#mobileMenuIconOpen');
	const $iconClose = $('#mobileMenuIconClose');

	if (!$toggleButton.length || !$mobileMenu.length || !$iconOpen.length || !$iconClose.length) {
		return;
	}

	let isOpen = false;

	function openMenu() {
		$mobileMenu.removeClass('max-h-0 opacity-0').addClass('opacity-100');
		$mobileMenu.css('max-height', $mobileMenu.prop('scrollHeight') + 'px');

		$iconOpen.addClass('hidden');
		$iconClose.removeClass('hidden');

		$toggleButton.attr('aria-expanded', 'true');
		isOpen = true;
	}

	function closeMenu() {
		$mobileMenu.css('max-height', $mobileMenu.prop('scrollHeight') + 'px');

		requestAnimationFrame(function () {
			$mobileMenu.css('max-height', '0px');
			$mobileMenu.removeClass('opacity-100').addClass('opacity-0');
		});

		$iconClose.addClass('hidden');
		$iconOpen.removeClass('hidden');

		$toggleButton.attr('aria-expanded', 'false');
		isOpen = false;
	}

	$toggleButton.on('click', function () {
		if (isOpen) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	$(window).on('resize', function () {
		if (window.innerWidth >= 1024) {
			$mobileMenu.css('max-height', '');
			$mobileMenu.removeClass('opacity-0 opacity-100 max-h-0');

			$iconClose.addClass('hidden');
			$iconOpen.removeClass('hidden');

			$toggleButton.attr('aria-expanded', 'false');
			isOpen = false;
		} else if (!isOpen) {
			$mobileMenu.css('max-height', '0px');
			$mobileMenu.addClass('max-h-0 opacity-0');
		}
	});
});